let Vue = require('vue');

Vue.component('questionPersonality', {
  data() {
    return {
      selected: false
    };
  },
  methods: {
    select(value, e) {
      this.markAsSelected(e);
      this.selected = true;
      this.scrollToNextQuestion();
      this.$emit('update-result', value);
    },

    markAsSelected(e) {
      const answerEl = e.target.closest('.m-question__answer');
      if (answerEl) {
        answerEl.classList.add('m-question__answer--selected');
      }
    },

    scrollToNextQuestion() {
      let next = this.$el.nextElementSibling;

      // Skip intermediate ad slots or wrappers
      while (next && next.classList.contains('cgIncontentSlotFix')) {
        next = next.nextElementSibling;
      }

      if (!next || !next.classList.contains('m-question')) return;

      this.$nextTick(() => {
        const targetPosition = next.getBoundingClientRect().top + window.scrollY;

        // Get <header> height
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;

        // Add base margin and safety offset
        const isMobile = window.innerWidth <= 768;
        const baseMargin = isMobile ? 16 : 32;
        const safetyOffset = 200;

        const offset = headerHeight + baseMargin + safetyOffset;

        // Scroll only if not already visible
        const alreadyVisible = next.getBoundingClientRect().top < window.innerHeight / 2;

        if (!alreadyVisible) {
          window.scrollTo({
            top: targetPosition - offset,
            left: 0,
            behavior: 'smooth'
          });
        }
      });
    }
  }
});
